module.exports = __webpack_public_path__ + "static/img/eyds_kamp.787faaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eyds_kamp.png
// module id = shMt
// module chunks = 1